import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux';

const ExitTimer = ({ countDownDate , setIsDiscount , isSticky}) => {

    const [time, setTime] = useState({});
  const timerRef = useRef();
  const [isTimerOn, setIsTimerOn] = useState(true);

  const discountAmount = useSelector((store) => store?.userDiscount?.discount);
  const discountData = useSelector((store) => store?.userDiscount);

    useEffect(() => {
        timerRef.current = setInterval(function () {
          const now = Date.now();
          const timeleft = countDownDate - now;
          const hours = Math.floor(timeleft / (1000 * 60 * 60));
          const minutes = Math.floor((timeleft % (1000 * 60 * 60)) / (1000 * 60));
          const seconds = Math.floor((timeleft % (1000 * 60)) / 1000);
          if (hours < 0 && minutes < 0 && seconds < 0) {
            setIsTimerOn(false);
            setIsDiscount(false);
          } else {
            setIsTimerOn(true);
            setIsDiscount(true);
          }
    
          // Result is output to the specific element
          // document.getElementById('days').innerHTML = days + 'd ';
          setTime({ h: hours, m: minutes, s: seconds });
    
          // Display the message when countdown is over
          if (timeleft < 0) {
            clearInterval(timerRef.current);
            // setTime to 0
          }
        }, 1000);
    
        return () => {
          clearInterval(timerRef.current);
        };
      }, [countDownDate]);

    return isTimerOn && discountData !== null ? (
    <>
      {isSticky? 
      <div
      className={`flex flex-col justify-center items-center text-sm font-medium
        }`}
    >
     <span>Discount Ends in:</span>
    <span className=" flex  flex-col justify-center items-center  rounded-md border-2 border-[#E06064] bg-white ">
      <div className="flex flex-row ">
      <div className="flex w-full mt-1 gap-1 px-1 font-bold text-xs text-[#E06064]">
        <div className="text-center">{time?.h}H</div>
        <div className="row-span-1 text-center md:row-span-2 ">:</div>
        <div className="text-center">{time?.m}M</div>
        <div className="row-span-1 text-center md:row-span-2">:</div>
        <div className="text-center">{time?.s}S</div>
      </div>
      </div>
    </span>
  </div>
      
      :<div
        className={`flex flex-row justify-center items-center text-sm font-medium mt-2
          }`}
      >
       Discount Expires In:
      <span className=" flex  flex-col items-center justify-center rounded-md border-2 border-[#F59E0B] ml-2 ">
        <div className="flex flex-row ">
        <div className="flex w-full gap-1 px-2 font-bold text-[#F59E0B]">
          <div className="text-center">{time?.h}H</div>
          <div className="row-span-1 text-center md:row-span-2 ">:</div>
          <div className="text-center">{time?.m}M</div>
          <div className="row-span-1 text-center md:row-span-2">:</div>
          <div className="text-center">{time?.s}S</div>
        </div>
        </div>
      </span>
    </div> }
    </>
  ) : (
    <></>
  );
};


export default ExitTimer
